import React, { useEffect, useState } from "react";
import SupervisorManager from "../../managers/SupervisorManager";
import { useMsal } from "@azure/msal-react";
import { Supervisor, SupervisorListResponse, SupervisorListPageProps } from "../../interfaces/SupervisorInterface"; // Import Supervisor interfaces
import "../wcdp/V1Pages/V1SupervisorListPage.css";
import Colors from '../../styles/Colors.json';
import { useSiteContext } from "../../SiteContext";
import { Page } from "../../interfaces/PagesInterface";
import PageWrapper from "../../components/PageWrapper";
import SearchBar from "../../components/SearchBar";
import { TimesheetType } from "../../interfaces/TimesheetInterface";

const VistaSupervisorListPage: React.FC<SupervisorListPageProps> = ({ setError }) => {
  const { payPeriodID, setSuperName, setSuperID, type, setPage, setLoading, translator, setSuperAltID, userID, userRole } = useSiteContext();

  // State to store fetched supervisor data and loading status
  const [data, setData] = useState<SupervisorListResponse | null>(null);

  // MSAL instance for Azure authentication
  const { instance, accounts } = useMsal();

  const [searchTerm, setSearchTerm] = useState<string>(""); // State to manage the search term

  // Fetch the supervisor data when the component mounts or when parameters change
  useEffect(() => {
    const fetchData = async () => {
      // Return early if necessary parameters are not available
      if (!payPeriodID) return;

      // Set loading state to true before fetching data
      setLoading(true);

      try {
        // Fetch data from the API using the msal instance, accounts, payPeriodID, and type
        const adminUserID = userRole.admin || userRole.payroll || userRole.hr ? undefined : userID;
        const response = await SupervisorManager.getSupervisors(payPeriodID, TimesheetType.PayApproved, adminUserID);
        
        // Set the fetched data into state
        setData(response.data);
        console.log(response);
      } catch (error) {
        // Handle any errors that occur during data fetching
        console.error("Error fetching data:", error);
        setError("Failed to fetch data. Please try again later.");
      } finally {
        // Stop loading after data fetch attempt is finished
        setLoading(false);
      }
    };

    fetchData();
  }, [payPeriodID, type, instance, accounts, setError, setLoading]);

  // Handle supervisor card click to navigate to the employee list page
  const handleClick = (supID: number, supName: string, supAltID: string,) => {
    console.log(supID);
    /*
    if (supID === null) {
      setSuperID(0);
      setSuperAltID('');
    } else {
      setSuperID(supID);
      setSuperAltID(supAltID);
    }
    setSuperName(supName);
    setPage(Page.V1Employees);
    */
  };

  // Filter supervisors based on the search term
  const filteredSupervisors = data?.supervisors?.filter((supervisor) => {
    const searchTermLower = searchTerm.toLowerCase(); // Convert search term to lowercase for case-insensitive comparison

    // Check if the search term contains letters (name search)
    if (/[a-zA-Z]/.test(searchTerm)) {
      const fullName = `${supervisor.name.first} ${supervisor.name.last}`.toLowerCase();
      return fullName.includes(searchTermLower); // Filter by name
    }

    // Otherwise, filter by altEmployeeID (number search)
    return supervisor.altEmployeeID?.toString().includes(searchTerm);
  }) || [];

  return (
    <PageWrapper title="Vista Time Batch Entry Export" backgroundColor={Colors.White} backArrow={true} weekSelector={true}>
      {/* Search bar */}
      <SearchBar
        placeholder={"Search Supervisors"}
        value={searchTerm}
        onChange={setSearchTerm} // Pass the setSearchTerm function to handle changes
        style={{width: '75%', border: "1px solid rgb(111, 111, 111)"}}
      />
      
      <div>
                {/* Check if there are any supervisors in the fetched data */}
                {filteredSupervisors.length > 0 ? (
                  // Map over the list of supervisors and render each one
                  filteredSupervisors.map((supervisor: Supervisor) => (
                    <div
                      key={supervisor.altEmployeeID} // Use altEmployeeID as key (if unique)
                      className="V1-supervisor-card"
                      onClick={() =>
                        handleClick(supervisor.employeeID, `${supervisor.name.last} - ${supervisor.name.first}`, supervisor.altEmployeeID)
                      }
                    >
                      {/* Display supervisor's name, employee ID, and count */}
                      <h4>{supervisor.name.last + " - " + supervisor.name.first + " " + (supervisor.altEmployeeID ?? supervisor.employeeID)}</h4>
                      <p><strong>{translator.translate("Count")} </strong>{supervisor.count}</p>
                    </div>
                  ))
                ) : (
                  <p className="no-data-message">{translator.translate("NoSupersFound")}</p>
                )}
              </div>
    </PageWrapper>
  );
};

export default VistaSupervisorListPage;
